<script lang="ts">
  let {
    position = 0,
    max = 100,
    background = "e0e0e0",
    color = "#659cef",
  } = $props();

  let percent: number = $derived(Math.floor((position * 100) / max));
</script>

<!-- HTML ===================================================== -->

<div class="progress-bar" style="background-color: {background};">
  <span
    class="progress-bar-fill"
    style="width: {percent}%; 
    background-color: {color};"
  ></span>
</div>

<!-- CSS ===================================================== -->
<style>
  .progress-bar {
    width: 100%;
    background-color: #e0e0e0;
    padding: 1px;
    border-radius: 3px;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .progress-bar-fill {
    display: block;
    height: 1vh;
    border-radius: 3px;
    transition: width 500ms ease-in-out;
  }
</style>
